import type { tr } from './tr';

/**
 * Sözlük şekli — Türkçe sözlükten TÜRETİLİR.
 *
 * Ayrı bir `interface` yazılmadı bilinçli olarak: iki yerde tutulan bir şema
 * er ya da geç ayrışır ve ayrışma sessiz olur. Tek kaynak `tr`; diğer diller
 * onun şeklini uygulamak zorundadır.
 */
export type Dictionary = typeof tr;

export const locales = ['tr', 'en'] as const;
export type Locale = (typeof locales)[number];

export const DEFAULT_LOCALE: Locale = 'tr';

/** Dil seçicide gösterilecek adlar — her zaman kendi dilinde yazılır. */
export const LOCALE_LABEL: Record<Locale, string> = {
  tr: 'Türkçe',
  en: 'English',
};

/** `Intl` çağrılarında kullanılacak BCP 47 etiketi. */
export const INTL_LOCALE: Record<Locale, string> = {
  tr: 'tr-TR',
  en: 'en-GB',
};

export function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}
